import React from 'react';
import SbEditable from 'storyblok-react';
import TextCard from '~/components/Dynamic/TextCard';
import styled from 'styled-components';
import tw from 'twin.macro';
const Container = styled.div`
  ${tw`flex flex-col justify-center`}
  .text-card {
    ${tw`flex`}
    &:not(:last-child) {
      ${tw`mb-12`}
    }
    > .text-card__icon {
      ${tw`mr-12`}
      flex: 0 0 60px;
      img {
        ${tw`object-contain w-full h-full mb-0`}
      }
    }
  }
`;

export default function InlineIconTextCards({ blok }) {
  return (
    <Container>
      <SbEditable content={blok} key={blok._uid}>
        {blok.textCard.map((card) => (
          <TextCard key={card._uid} blok={card} />
        ))}
      </SbEditable>
    </Container>
  );
}
